import React from "react";
import Container from "@/components/marketing/Container";
import SectionHeading from "@/components/marketing/SectionHeading";
import { Link } from "react-router-dom";
import { ArrowRight, Newspaper, FileCheck, Languages } from "lucide-react";

const WIRES = [
  {
    icon: Newspaper,
    name: "Gulf Newswire",
    desc: "Focused distribution across Gulf Cooperation Council media. Reach journalists and publications in the UAE, Saudi Arabia, Qatar, Kuwait, Bahrain, and Oman. From $475.",
    reach: "GCC-wide coverage",
    to: "/gulf-newswire",
  },
  {
    icon: Languages,
    name: "Arabic Newswire",
    desc: "Native Arabic translation and syndication. Your release goes out in Arabic to publications and journalists across the Arab world.",
    reach: "Arabic-language outlets",
  },
  {
    icon: FileCheck,
    name: "Google News MENA",
    desc: "Get indexed in Google News across the MENA region. Your announcement appears in news search results for Arabic and English queries.",
    reach: "Google News indexed",
  },
];

export default function UaeNewswires() {
  return (
    <section className="py-12 lg:py-16 bg-slate/30">
      <Container>
        <SectionHeading
          tag="UAE NEWSWIRES"
          title="Syndicate across the UAE and Gulf."
          subtitle="Broad, fast, defined reach. Pick one wire or combine several by language or sub-region. Every newswire comes with a full pickup report."
        />

        <div className="grid md:grid-cols-2 gap-5 lg:gap-6">
          {WIRES.map((w) => (
            <div
              key={w.name}
              className="group bg-white border border-border rounded-xl p-7 lg:p-8 flex flex-col hover:border-cobalt/30 transition-colors"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-cobalt/5 shrink-0">
                  <w.icon className="w-6 h-6 text-cobalt" strokeWidth={1.75} />
                </div>
                <div>
                  <h3 className="font-heading text-lg font-bold text-bone">{w.name}</h3>
                  <span className="text-xs font-mono uppercase tracking-wider text-cobalt mt-1 inline-block">{w.reach}</span>
                </div>
              </div>
              <p className="text-sm text-steel leading-relaxed mb-5">{w.desc}</p>
              {w.to && (
                <Link to={w.to} className="inline-flex items-center text-sm font-medium text-cobalt hover:text-cobalt/80 transition-colors mt-auto">
                  Learn more <ArrowRight className="ml-1.5 w-4 h-4" />
                </Link>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/services/newswire-distribution"
            className="inline-flex items-center text-sm font-medium text-cobalt hover:text-cobalt/80 transition-colors"
          >
            Browse all newswires <ArrowRight className="ml-1.5 w-4 h-4" />
          </Link>
        </div>
      </Container>
    </section>
  );
}